import { Directive, EventEmitter, Input, Output } from "@angular/core";
import { NzRowExpandButtonDirective } from "ng-zorro-antd/table";

@Directive({
  selector: "button[ui-row-expand-button]",
})
export class UiRowExpandButtonDirective extends NzRowExpandButtonDirective {
  @Input("expand") public expand = false;
  @Input("spaceMode") public spaceMode = false;
  @Output("expandChange") public readonly expandChange = new EventEmitter();
}
